// The single place that knows which tool belongs to which review section.
// Adding a record type later is one entry here, not an edit across components.
export const SECTIONS = [
  { id: 'locations',      title: 'Locations',       tools: ['create_location'] },
  { id: 'contacts',       title: 'Contacts',        tools: ['create_contact'] },
  { id: 'configurations', title: 'Configurations',  tools: ['create_configuration'] },
  { id: 'passwords',      title: 'Passwords',       tools: ['create_password'] },
  { id: 'flexAssets',     title: 'Flexible assets', tools: ['create_flexible_asset'] },
];

export function sectionFor(tool) {
  const hit = SECTIONS.find((s) => s.tools.includes(tool));
  return hit ? hit.id : null;
}

export function typeLabel(item, schemas = {}) {
  if (item.tool !== 'create_flexible_asset') return '';
  const id = item.params?.flexibleAssetTypeId;
  const schema = schemas[String(id)];
  return schema?.label || `Unrecognised type ${id}`;
}

// The single source of truth for "what is this record called". Most tools
// carry their name at params.name/firstName, but create_flexible_asset
// items carry it inside params.traits — this is the exact fallback chain
// the pre-wizard page's `summariseToolRow` used (lost in the cut-over to
// the wizard; restored here as the one place that knows it).
const FLEX_NAME_TRAIT_CHAIN = ['name', 'ssid', 'network-name', 'backup-description', 'vendor-name', 'site'];

export function recordName(item) {
  const p = item.params || {};
  if (p.name) return p.name;
  if (p.firstName) return p.firstName;
  if (item.tool === 'create_flexible_asset') {
    const traits = p.traits || {};
    for (const key of FLEX_NAME_TRAIT_CHAIN) {
      if (traits[key]) return traits[key];
    }
  }
  return '(unnamed)';
}

// Up to three short strings identifying the record at a glance.
export function keyFields(item, schemas = {}) {
  const p = item.params || {};
  if (item.tool === 'create_flexible_asset') {
    const traits = p.traits || {};
    return [typeLabel(item, schemas), traits.location, traits.site].filter(Boolean).slice(0, 3);
  }
  if (item.tool === 'create_password') {
    return [p.username, p['resource-name']].filter(Boolean).slice(0, 3);
  }
  return [p['configuration-type'], p['primary-ip'], p.city].filter(Boolean).slice(0, 3);
}
